import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../helpers'
import {EmailIcon} from '../../../../../app/icons/EmailIcon'

type Props = {
  className: string
}

const EngageWidget10 = ({className}: Props) => (
  <div className={`card card-flush ${className}`}>
    <div
      className='card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-center pb-0'
      style={{
        background: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url('${toAbsoluteUrl(
          '/media/logos/lums3.png'
        )}')`,
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div className='mb-10'>
        <div className='fs-2hx fw-bold text-gray-800 text-center mb-13'>
          Colorado IIJA - IRA Workforce Dashboard
        </div>

        {/* Begin: Message */}
        <div className='text-right mt-5 fw-normal' style={{fontSize: '1.3em'}}>
          <p>
            On behalf of the <strong>Governor's Office</strong> and{' '}
            <strong>State Agency partners</strong>, the{' '}
            <strong>Colorado Workforce Development Council</strong> is excited to share this
            resource with all communities in Colorado.
          </p>
          <p>
            The <strong>IIJA</strong> creates tremendous opportunities for investments in our
            state's infrastructure and our workforce.
          </p>
          <p>
            We hope the data shared here will help you be successful in implementing new projects.
          </p>
          <p>
            Questions?{' '}
            <a href='mailto:cwdc@state.co.us'>
              <strong>cwdc@state.co.us</strong>
            </a>
          </p>
        </div>
        {/* End: Message */}
      </div>
      {/* Begin: Logo */}
      <div className='text-center mb-5'>
        <a href='https://cwdc.colorado.gov/' target='_blank' rel='noopener noreferrer'>
          <img
            src='https://luminancedata.com/wp-content/uploads/2023/10/logo.svg'
            alt='Luminance Data Logo'
            style={{height: '130px'}}
          />
        </a>
      </div>

      {/* End: Logo */}
    </div>
  </div>
)

export {EngageWidget10}
